import React from 'react';
import { observer } from 'mobx-react';
import { mdiAccountPlus } from '@mdi/js';
import Icon from '@mdi/react';
import { Link } from 'react-router-dom';

export const AdminProjectOwners = observer(({ userData, openModalChangeOwner, onClickViewProjects }) => {
  return (
    <table className="usa-table usa-table--borderless">
      <thead className="">
        <tr className="projectOwner-table-head">
          <th scope="col" className="w-50">
            Full Name
          </th>
          <th scope="col" className="nobr">
            # of Projects
          </th>
          <th scope="col">Action</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        {userData.map((user, index) => (
          <tr key={index}>
            <th scope="row">
              {/* <label className="usa-radio">
                <input className="usa-radio__input" id={`${index}`} type="radio" name="userName" />
                <div className="usa-radio__label">{user.userName}</div>
              </label> */}
              {user.userName}
            </th>
            <td>{user.projectCount}</td>
            <td>
              <Link to={`/admin/project-owner/${user.coreUserId}`} className="usa-button--unstyled nobr" onClick={() => onClickViewProjects(user)}>
                View Projects
              </Link>
            </td>
            <td>
              <button className="usa-button--unstyled nobr" onClick={() => openModalChangeOwner(user)}>
                <Icon path={mdiAccountPlus} size={1} className="mr-1" />
                Change Owner
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
});
